import React, { useState , useEffect } from "react";
import "./finalBookForm.css"; // custom styles

import BookingEmailVerificationPopup from "./BookingEmailVerificationPopup";


const FinalBookingForm = ({ property }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    city: "",
    zipCode: "",
    country: "Pakistan",
    phoneCode: "+92",
    phoneNumber: "",
    bookingFor: "mainGuest",
    workTravel: "no",
    breakfast: false,

     shuttle: false,
      carRental: false,
      taxi: false,
specialRequest: "",
    parking: false,

// Crib :"",
arrivalTime :"",

isCribAvailable :"",
noOfCribs :"",

isExtraBedAvailable :"",
noOfExtraBeds :"",

  });



  useEffect(() => {


console.log(
  property

)

  }, []);











  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };







//   const handleSubmit = () => {



//      const { firstName, lastName, email, address, phoneNumber } = formData;
//   if (!firstName || !lastName || !email || !address || !phoneNumber) {
//     toast.success("Please fill in all required fields before proceeding.");
//     return;
//   }



//   console.log("Form Data:", formData);
//   console.log("Property Data:", property);


//   localStorage.setItem("AllBookingData", JSON.stringify({
//     property ,
//     formData
//   }))

//       setShowPopup(true); // popup yahan open karo jab response mile

// };


const handleSubmit = () => {
  // Destructure all required fields from formData
  const {
    firstName,
    lastName,
    email,
    address,
    city,
    zipCode,
    country,
    phoneCode,
    phoneNumber,
    bookingFor,
    workTravel,
  } = formData;

  // Array of required fields
  const requiredFields = [
    { value: firstName, name: "First Name" },
    { value: lastName, name: "Last Name" },
    { value: email, name: "Email" },
    { value: address, name: "Address" },
    { value: city, name: "City" },
    { value: zipCode, name: "Zip Code" },
    { value: country, name: "Country" },
    { value: phoneCode, name: "Phone Code" },
    { value: phoneNumber, name: "Phone Number" },
    { value: bookingFor, name: "Booking For" },
    { value: workTravel, name: "Work Travel" },
  ];

  // Find missing fields
  const missingFields = requiredFields
    .filter((field) => !field.value || field.value === "")
    .map((field) => field.name);

  if (missingFields.length > 0) {
    alert(
      "Please fill in the following required fields:\n" +
        missingFields.join(", ")
    );
    return; // Stop if any field is missing
  }

  // Save data to localStorage
  localStorage.setItem(
    "AllBookingData",
    JSON.stringify({ property, formData })
  );

  // Open popup
  setShowPopup(true);
};

  return (

    <>
    <div className="booking-form">
      <h3 className="form-title">Enter your details</h3>
      <p className="form-subtitle">
        <span className="check-icon">✔</span> Almost done! Just fill in the{" "}
        <span className="required">*</span> required info
      </p>

      <div>
      {/* Name */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label className="form-label">
            First name <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">
            Last name <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Email */}
      <div className="mb-3">
        <label className="form-label">
          Email address <span className="required">*</span>
        </label>
        <input
          type="email"
          className="form-control"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />
        <small className="text-muted">
          Confirmation email sent to this address
        </small>
      </div>

      {/* Address */}
      <div className="mb-3">
        <label className="form-label">
          Address <span className="required">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="address"
          value={formData.address}
          onChange={handleChange}
        />
      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <label className="form-label">City</label>
          <input
            type="text"
            className="form-control"
            name="city"
            value={formData.city}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Zip Code (optional)</label>
          <input
            type="text"
            className="form-control"
            name="zipCode"
            value={formData.zipCode}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Country */}
      <div className="mb-3">
        <label className="form-label">
          Country/Region <span className="required">*</span>
        </label>
        <select
          className="form-select"
          name="country"
          value={formData.country}
          onChange={handleChange}
        >
            <option>Pakistan</option>
  <option>India</option>
  <option>USA</option>
  <option>UAE</option>
  <option>United Kingdom</option>
  <option>Canada</option>
  <option>Australia</option>
  <option>Austria</option>
  <option>Bahrain</option>
  <option>Bangladesh</option>
  <option>Belgium</option>
  <option>China</option>
  <option>France</option>
  <option>Germany</option>
  <option>Kuwait</option>
  <option>Oman</option>
  <option>Qatar</option>
  <option>Russia</option>
  <option>Saudi Arabia</option>
  <option>Singapore</option>
  <option>Mexico</option>
  <option>Morocco</option>
  <option>Netherlands</option>
  <option>Norway</option>
  <option>Spain</option>

  {/* Rest of the world in alphabetical order */}
  <option>Afghanistan</option>
  <option>Azerbaijan</option>
  <option>Brazil</option>
  <option>Colombia</option>
  <option>Denmark</option>
  <option>Egypt</option>
  <option>Finland</option>
  <option>Indonesia</option>
  <option>Iran</option>
  <option>Iraq</option>
  <option>Ireland</option>
  <option>Israel</option>
  <option>Italy</option>
  <option>Japan</option>
  <option>Jordan</option>
  <option>Lebanon</option>
  <option>Libya</option>
  <option>Malaysia</option>
  <option>Maldives</option>
  <option>Palestine</option>
  <option>Philippines</option>
  <option>Poland</option>
  <option>Portugal</option>
  <option>Romania</option>
  <option>Switzerland</option>
  <option>South Africa</option>
  <option>South Korea</option>
  <option>South Sudan</option>
  <option>Sri Lanka</option>
  <option>Sudan</option>
  <option>Sweden</option>
  <option>Syria</option>
  <option>Taiwan</option>
  <option>Tajikistan</option>
  <option>Thailand</option>
  <option>Turkey</option>
  <option>Turkmenistan</option>
  <option>Ukraine</option>
  <option>Uzbekistan</option>
  <option>Vietnam</option>
  <option>Yemen</option>
  <option>Zimbabwe</option>







  <option>Albania</option>
  <option>Algeria</option>
  <option>Andorra</option>
  <option>Angola</option>
  <option>Argentina</option>
  <option>Armenia</option>
  <option>Bahamas</option>
  <option>Barbados</option>
  <option>Belarus</option>
  <option>Belize</option>
  <option>Benin</option>
  <option>Bhutan</option>
  <option>Bolivia</option>
  <option>Bosnia and Herzegovina</option>
  <option>Botswana</option>
  <option>Brunei</option>
  <option>Bulgaria</option>
  <option>Burkina Faso</option>
  <option>Burundi</option>
  <option>Cabo Verde</option>
  <option>Cambodia</option>
  <option>Cameroon</option>
  <option>Central African Republic</option>
  <option>Chad</option>
  <option>Chile</option>
  <option>Comoros</option>
  <option>Congo</option>
  <option>Costa Rica</option>
  <option>Croatia</option>
  <option>Cuba</option>
  <option>Cyprus</option>
  <option>Czechia</option>
  <option>Djibouti</option>
  <option>Dominica</option>
  <option>Dominican Republic</option>
  <option>Ecuador</option>
  <option>El Salvador</option>
  <option>Equatorial Guinea</option>
  <option>Eritrea</option>
  <option>Estonia</option>
  <option>Eswatini</option>
  <option>Ethiopia</option>
  <option>Fiji</option>
  <option>Gabon</option>
  <option>Gambia</option>
  <option>Georgia</option>
  <option>Ghana</option>
  <option>Greece</option>
  <option>Grenada</option>
  <option>Guatemala</option>
  <option>Guinea</option>
  <option>Guinea-Bissau</option>
  <option>Guyana</option>
  <option>Haiti</option>
  <option>Honduras</option>









  <option>Hungary</option>
  <option>Iceland</option>
  <option>Jamaica</option>
  <option>Kazakhstan</option>
  <option>Kenya</option>
  <option>Kyrgyzstan</option>
  <option>Laos</option>
  <option>Latvia</option>
  <option>Lesotho</option>
  <option>Liberia</option>
  <option>Liechtenstein</option>
  <option>Lithuania</option>
  <option>Luxembourg</option>
  <option>Madagascar</option>
  <option>Malawi</option>
  <option>Mali</option>
  <option>Malta</option>
  <option>Marshall Islands</option>
  <option>Mauritania</option>
  <option>Mauritius</option>
  <option>Micronesia</option>
  <option>Moldova</option>
  <option>Monaco</option>
  <option>Mongolia</option>
  <option>Montenegro</option>
  <option>Mozambique</option>
  <option>Myanmar</option>
  <option>Namibia</option>
  <option>Nauru</option>
  <option>Nepal</option>
  <option>New Zealand</option>
  <option>Nicaragua</option>
  <option>Niger</option>
  <option>Nigeria</option>
  <option>North Korea</option>
  <option>North Macedonia</option>
  <option>Palau</option>
  <option>Panama</option>
  <option>Papua New Guinea</option>
  <option>Paraguay</option>
  <option>Peru</option>
  <option>Rwanda</option>
  <option>Saint Kitts and Nevis</option>
  <option>Saint Lucia</option>
  <option>Saint Vincent and the Grenadines</option>
  <option>Samoa</option>
  <option>San Marino</option>
  <option>Sao Tome and Principe</option>
  <option>Senegal</option>
  <option>Serbia</option>
  <option>Seychelles</option>
  <option>Sierra Leone</option>
  <option>Slovakia</option>
  <option>Slovenia</option>
  <option>Solomon Islands</option>
  <option>Somalia</option>
  <option>Suriname</option>
  <option>Tanzania</option>
  <option>Timor-Leste</option>
  <option>Togo</option>
  <option>Tonga</option>
  <option>Trinidad and Tobago</option>
  <option>Tunisia</option>
  <option>Tuvalu</option>
  <option>Uganda</option>
  <option>Uruguay</option>
  <option>Vanuatu</option>
  <option>Vatican City</option>
  <option>Venezuela</option>
  <option>Zambia</option>
        </select>
      </div>

      {/* Phone */}
      <div className="row mb-3">
        <div className="col-md-3">
          <label className="form-label">Phone code</label>
          <select
            className="form-select"
            name="phoneCode"
            value={formData.phoneCode}
            onChange={handleChange}
          >
     <option value="+92">Pakistan (+92)</option>
<option value="+91">India (+91)</option>
<option value="+1">USA (+1)</option>
<option value="+971">UAE (+971)</option>
<option value="+44">United Kingdom (+44)</option>
<option value="+1">Canada (+1)</option>
<option value="+61">Australia (+61)</option>
<option value="+43">Austria (+43)</option>
<option value="+973">Bahrain (+973)</option>
<option value="+880">Bangladesh (+880)</option>
<option value="+32">Belgium (+32)</option>
<option value="+86">China (+86)</option>
<option value="+33">France (+33)</option>
<option value="+49">Germany (+49)</option>
<option value="+965">Kuwait (+965)</option>
<option value="+968">Oman (+968)</option>
<option value="+974">Qatar (+974)</option>
<option value="+7">Russia (+7)</option>
<option value="+966">Saudi Arabia (+966)</option>
<option value="+65">Singapore (+65)</option>
<option value="+52">Mexico (+52)</option>
<option value="+212">Morocco (+212)</option>
<option value="+31">Netherlands (+31)</option>
<option value="+47">Norway (+47)</option>
<option value="+34">Spain (+34)</option>


<option value="+93">Afghanistan (+93)</option>
<option value="+994">Azerbaijan (+994)</option>
<option value="+55">Brazil (+55)</option>
<option value="+57">Colombia (+57)</option>
<option value="+45">Denmark (+45)</option>
<option value="+20">Egypt (+20)</option>
<option value="+358">Finland (+358)</option>
<option value="+62">Indonesia (+62)</option>
<option value="+98">Iran (+98)</option>
<option value="+964">Iraq (+964)</option>
<option value="+353">Ireland (+353)</option>
<option value="+972">Israel (+972)</option>
<option value="+39">Italy (+39)</option>
<option value="+81">Japan (+81)</option>
<option value="+962">Jordan (+962)</option>
<option value="+961">Lebanon (+961)</option>
<option value="+218">Libya (+218)</option>
<option value="+60">Malaysia (+60)</option>
<option value="+960">Maldives (+960)</option>
<option value="+970">Palestine (+970)</option>
<option value="+63">Philippines (+63)</option>
<option value="+48">Poland (+48)</option>
<option value="+351">Portugal (+351)</option>
<option value="+40">Romania (+40)</option>
<option value="+41">Switzerland (+41)</option>
<option value="+27">South Africa (+27)</option>
<option value="+82">South Korea (+82)</option>
<option value="+211">South Sudan (+211)</option>
<option value="+94">Sri Lanka (+94)</option>
<option value="+249">Sudan (+249)</option>
<option value="+46">Sweden (+46)</option>
<option value="+963">Syria (+963)</option>
<option value="+886">Taiwan (+886)</option>
<option value="+992">Tajikistan (+992)</option>
<option value="+66">Thailand (+66)</option>
<option value="+90">Turkey (+90)</option>
<option value="+993">Turkmenistan (+993)</option>
<option value="+380">Ukraine (+380)</option>
<option value="+998">Uzbekistan (+998)</option>
<option value="+84">Vietnam (+84)</option>
<option value="+967">Yemen (+967)</option>
<option value="+263">Zimbabwe (+263)</option>

<option value="+355">Albania +355</option>
<option value="+213">Algeria +213</option>
<option value="+376">Andorra +376</option>
<option value="+244">Angola +244</option>
<option value="+54">Argentina +54</option>
<option value="+374">Armenia +374</option>
<option value="+1-242">Bahamas +1-242</option>
<option value="+1-246">Barbados +1-246</option>
<option value="+375">Belarus +375</option>
<option value="+501">Belize +501</option>
<option value="+229">Benin +229</option>
<option value="+975">Bhutan +975</option>
<option value="+591">Bolivia +591</option>
<option value="+387">Bosnia and Herzegovina +387</option>
<option value="+267">Botswana +267</option>
<option value="+673">Brunei +673</option>
<option value="+359">Bulgaria +359</option>
<option value="+226">Burkina Faso +226</option>
<option value="+257">Burundi +257</option>
<option value="+238">Cabo Verde +238</option>
<option value="+855">Cambodia +855</option>
<option value="+237">Cameroon +237</option>
<option value="+236">Central African Republic +236</option>
<option value="+235">Chad +235</option>
<option value="+56">Chile +56</option>
<option value="+269">Comoros +269</option>
<option value="+242">Congo +242</option>
<option value="+506">Costa Rica +506</option>
<option value="+385">Croatia +385</option>
<option value="+53">Cuba +53</option>
<option value="+357">Cyprus +357</option>
<option value="+420">Czechia +420</option>
<option value="+253">Djibouti +253</option>
<option value="+1-767">Dominica +1-767</option>
<option value="+1-809">Dominican Republic +1-809</option>
<option value="+593">Ecuador +593</option>
<option value="+503">El Salvador +503</option>
<option value="+240">Equatorial Guinea +240</option>
<option value="+291">Eritrea +291</option>
<option value="+372">Estonia +372</option>
<option value="+268">Eswatini +268</option>
<option value="+251">Ethiopia +251</option>
<option value="+679">Fiji +679</option>
<option value="+241">Gabon +241</option>
<option value="+220">Gambia +220</option>
<option value="+995">Georgia +995</option>
<option value="+233">Ghana +233</option>
<option value="+30">Greece +30</option>
<option value="+1-473">Grenada +1-473</option>
<option value="+502">Guatemala +502</option>
<option value="+224">Guinea +224</option>
<option value="+245">Guinea-Bissau +245</option>
<option value="+592">Guyana +592</option>
<option value="+509">Haiti +509</option>
<option value="+504">Honduras +504</option>
<option value="+36">Hungary +36</option>
<option value="+354">Iceland +354</option>
<option value="+1-876">Jamaica +1-876</option>
<option value="+7">Kazakhstan +7</option>
<option value="+254">Kenya +254</option>
<option value="+996">Kyrgyzstan +996</option>
<option value="+856">Laos +856</option>
<option value="+371">Latvia +371</option>
<option value="+266">Lesotho +266</option>
<option value="+231">Liberia +231</option>
<option value="+423">Liechtenstein +423</option>
<option value="+370">Lithuania +370</option>
<option value="+352">Luxembourg +352</option>
<option value="+261">Madagascar +261</option>
<option value="+265">Malawi +265</option>
<option value="+223">Mali +223</option>
<option value="+356">Malta +356</option>
<option value="+692">Marshall Islands +692</option>
<option value="+222">Mauritania +222</option>
<option value="+230">Mauritius +230</option>
<option value="+691">Micronesia +691</option>
<option value="+373">Moldova +373</option>
<option value="+377">Monaco +377</option>
<option value="+976">Mongolia +976</option>
<option value="+382">Montenegro +382</option>
<option value="+258">Mozambique +258</option>
<option value="+95">Myanmar +95</option>
<option value="+264">Namibia +264</option>
<option value="+674">Nauru +674</option>
<option value="+977">Nepal +977</option>
<option value="+64">New Zealand +64</option>
<option value="+505">Nicaragua +505</option>
<option value="+227">Niger +227</option>
<option value="+234">Nigeria +234</option>
<option value="+850">North Korea +850</option>


<option value="+389">North Macedonia +389</option>
<option value="+680">Palau +680</option>
<option value="+507">Panama +507</option>
<option value="+675">Papua New Guinea +675</option>
<option value="+595">Paraguay +595</option>
<option value="+51">Peru +51</option>
<option value="+250">Rwanda +250</option>
<option value="+1-869">Saint Kitts and Nevis +1-869</option>
<option value="+1-758">Saint Lucia +1-758</option>
<option value="+1-784">Saint Vincent and the Grenadines +1-784</option>
<option value="+685">Samoa +685</option>
<option value="+378">San Marino +378</option>
<option value="+239">Sao Tome and Principe +239</option>
<option value="+221">Senegal +221</option>
<option value="+381">Serbia +381</option>
<option value="+248">Seychelles +248</option>
<option value="+232">Sierra Leone +232</option>
<option value="+421">Slovakia +421</option>
<option value="+386">Slovenia +386</option>
<option value="+677">Solomon Islands +677</option>
<option value="+252">Somalia +252</option>
<option value="+597">Suriname +597</option>
<option value="+255">Tanzania +255</option>
<option value="+670">Timor-Leste +670</option>
<option value="+228">Togo +228</option>
<option value="+676">Tonga +676</option>
<option value="+1-868">Trinidad and Tobago +1-868</option>
<option value="+216">Tunisia +216</option>
<option value="+688">Tuvalu +688</option>
<option value="+256">Uganda +256</option>
<option value="+598">Uruguay +598</option>
<option value="+678">Vanuatu +678</option>
<option value="+379">Vatican City +379</option>
<option value="+58">Venezuela +58</option>
<option value="+260">Zambia +260</option>



          </select>
        </div>
        <div className="col-md-9">
          <label className="form-label">
            Phone number <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
          />
          <small className="text-muted">
            To verify your booking, and for the property to connect if needed
          </small>
        </div>
      </div>

      {/* Radio groups */}
      <div className="mb-3">
        <label className="form-label">Who are you booking for? (optional)</label>
        <div>
          <input
            type="radio"
            name="bookingFor"
            value="mainGuest"
            checked={formData.bookingFor === "mainGuest"}
            onChange={handleChange}
          />{" "}
          I'm the main guest
        </div>
        <div>
          <input
            type="radio"
            name="bookingFor"
            value="someoneElse"
            checked={formData.bookingFor === "someoneElse"}
            onChange={handleChange}
          />{" "}
          I'm booking for someone else
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">
          Are you traveling for work? (optional)
        </label>
        <div>
          <input
            type="radio"
            name="workTravel"
            value="yes"
            checked={formData.workTravel === "yes"}
            onChange={handleChange}
          />{" "}
          Yes
        </div>
        <div>
          <input
            type="radio"
            name="workTravel"
            value="no"
            checked={formData.workTravel === "no"}
            onChange={handleChange}
          />{" "}
          No
        </div>
      </div>

      {/* <button type="submit" className="btn btn-primary">
        Submit
      </button> */}
    </div>
    </div>





<br />



<div className="booking-summary">
      {/* Good to know */}
      <div className="info-card">
        <h5 className="section-title">Good to know:</h5>
        <p className="text-success">
          ✅ No payment needed now. You'll pay at the property.
        </p>
        {/* <p className="text-danger">
          ❌ You're booking the last available Deluxe King Room - Smoking we have at Ramada by Wyndham Karachi Creek on our site.
        </p> */}
      </div>

      {/* Deluxe Room */}
      <div className="info-card">
        <h5 className="section-title">Deluxe King Room - Smoking</h5>
        <ul className="details-list">
          <li className="text-success">🥞 Breakfast included in the price</li>
          <li>💰 Total cost to cancel</li>
          <li>👥 Guests: 2 adults
             {/* <span className="link">Add main guest details</span> */}
             </li>
          {/* <li>🧹 Cleanliness score – 7.1</li> */}
          <li>🚬 Smoking Not Allow</li>
        </ul>
      </div>

      {/* Add to your stay */}
      <div className="info-card">
        <h5 className="section-title">Add to your stay</h5>
        <div className="addon-option">
          <input
            type="checkbox"
            id="shuttle"
            name="shuttle"
            checked={formData.shuttle}
            onChange={handleChange}
          />
          <label htmlFor="shuttle">
            I'm interested in requesting an airport shuttle
            <small>
              We’ll tell your accommodation you’re interested, so they can
              provide details and costs.
            </small>
          </label>
        </div>

        <div className="addon-option">
          <input
            type="checkbox"
            id="carRental"
            name="carRental"
            checked={formData.carRental}
            onChange={handleChange}
          />
          <label htmlFor="carRental">
            I'm interested in renting a car with 5% off
            <small>
              Save 5% on all rental cars when you book with us – we’ll add car
              rental options to your booking confirmation.
            </small>
          </label>
        </div>

        <div className="addon-option">
          <input
            type="checkbox"
            id="taxi"
            name="taxi"
            checked={formData.taxi}
            onChange={handleChange}
          />
          <label htmlFor="taxi">
            Want to book a taxi or shuttle ride in advance?
            <small>
              Avoid surprises – get from the airport to your accommodation
              without hassle. We’ll add taxi options to your booking
              confirmation.
            </small>
          </label>
        </div>
      </div>
    </div>




 
    <div className="booking-extras">
      {/* Special requests */}
      <div className="info-card">
        <h5 className="section-title">Special requests</h5>
        <p className="info-text">
          Special requests can’t be guaranteed, but the property will do its best
          to meet your needs. You can always make a special request after your
          booking is complete.
        </p>
        <label className="label-text">
          Please write your requests in English. (optional)
        </label>
        <textarea className="form-control" name="specialRequest" value={formData.specialRequest}
          onChange={handleChange}
          placeholder="Write your special requests here..." rows="3"></textarea>



{/* 
        <div className="checkbox-option">
          <input type="checkbox" id="parking" 
          name="parking"
          checked={formData.parking}
          onChange={handleChange} />
          <label htmlFor="parking">I'd like free private parking on site</label>
        </div> */}





{/* {property.property.parking?.available && property.property.parking?.parkingType && (
  <div className="checkbox-option">
    {(property.property.parking.parkingType === "private" && property.property.parking.type === "free") ||
     (property.property.parking.parkingType === "public" && property.property.parking.type === "free") ? (
      <>
        <input
          type="checkbox"
          id="parking"
          name="parking"
          checked={formData.parking || false}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, parking: e.target.checked }))
          }
        />
        <label htmlFor="parking">I'd like free parking on site</label>
      </>
    ) : null}

    {(property.property.parking.parkingType === "private" && property.property.parking.type === "paid") ||
     (property.property.parking.parkingType === "public" && property.property.parking.type === "paid") ? (
      <>
        <input
          type="checkbox"
          id="parkingPaid"
          name="parking"
          checked={formData.parking || false}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, parking: e.target.checked }))
          }
        />
        <label htmlFor="parkingPaid">
          I'd like parking on site for {property.property.parking.cost} PKR
        </label>
      </>
    ) : null}
  </div>
)} */}

{property.property.parking?.available && (
  <div className="checkbox-option">
    {property.property.parking.type === "free" && (
      <>
        <input
          type="checkbox"
          id="parking"
          name="parking"
          checked={formData.parking || false}
          // onChange={handleChange}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, parking: e.target.checked }))
          }
        />
        <label htmlFor="parkingFree">I'd like free parking on site</label>
      </>
    )}

    {property.property.parking.type === "paid" && (
      <>
        <input
          type="checkbox"
          id="parking"
          name="parking"
          checked={formData.parking || false}
          // onChange={handleChange}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, parking: e.target.checked }))
          }
        />
        <label htmlFor="parkingPaid">
          I'd like parking on site for {property.property.parking.cost} PKR/night - ( For {property?.stayDurationInDays} Day{property?.stayDurationInDays > 1 ? "s" : ""} Stay The Price is - PKR {property.property.parking.cost*property.stayDurationInDays} )
        </label>
      </>
    )}
  </div>
)}



{property.Room.breakfast?.available && (
  <div className="checkbox-option">
    {property.Room.breakfast.included ? (
      <>
        <input
          type="checkbox"
          id="breakfast"
          name="breakfast"
          checked={formData.breakfast || false}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, breakfast: e.target.checked }))
          }
        />
        <label htmlFor="breakfast">
          I'd like breakfast included with my stay
        </label>
      </>
    ) : (
      <>
        <input
          type="checkbox"
          id="breakfast"
          name="breakfast"
          checked={formData.breakfast || false}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, breakfast: e.target.checked }))
          }
        />
        <label htmlFor="breakfast">
          I'd like to add breakfast for {property.Room.breakfast.price} PKR /night - ( For {property?.stayDurationInDays} Day{property?.stayDurationInDays > 1 ? "s" : ""} Stay with {property?.noOfRooms} of Rooms. The Price is - PKR {(property.Room.breakfast.price*property.stayDurationInDays) *property?.noOfRooms } )
        </label>
<br />
        {property.Room.breakfast.types?.length > 0 && (
          <div className="breakfast-types">
            <small>
              Available types:{" "}
              {property.Room.breakfast.types.join(", ")}
            </small>
          </div>
        )}
      </>
    )}
  </div>
)}




      </div>

      {/* Arrival time */}
      <div className="info-card">
        <h5 className="section-title">Your arrival time</h5>
        <p className="text-success">
          ✅ Your room will be ready for check-in between 12:30 PM and 2:00 PM
        </p>
        <p>🕑 24-hour front desk – help whenever you need it!</p>
        <label className="label-text">
          Add your estimated arrival time (optional)
        </label>
        <select className="form-control" name="arrivalTime" value={formData.arrivalTime}
            onChange={handleChange}>
          <option>Please select</option>
  <option>12:00 AM</option>
  <option>1:00 AM</option>
  <option>2:00 AM</option>
  <option>3:00 AM</option>
  <option>4:00 AM</option>
  <option>5:00 AM</option>
  <option>6:00 AM</option>
  <option>7:00 AM</option>
  <option>8:00 AM</option>
  <option>9:00 AM</option>
  <option>10:00 AM</option>
  <option>11:00 AM</option>
  <option>12:00 PM</option>
  <option>1:00 PM</option>
  <option>2:00 PM</option>
  <option>3:00 PM</option>
  <option>4:00 PM</option>
  <option>5:00 PM</option>
  <option>6:00 PM</option>
  <option>7:00 PM</option>
  <option>8:00 PM</option>
  <option>9:00 PM</option>
  <option>10:00 PM</option>
  <option>11:00 PM</option>
        </select>
        <small className="hint-text">Time is for Karachi time zone</small>
      </div>

      {/* Cribs and extra beds */}
      {/* <div className="info-card">
        <h5 className="section-title">Cribs and extra beds</h5>
        <ul className="info-list">
          <li>Requests are subject to availability</li>
          <li>Requests need to be confirmed by the property</li>
          <li>
            Requests not labeled "Free" could incur extra charges
          </li>
        </ul>
        <a href="#" className="policy-link">
          Read full crib and extra bed policy
        </a>

        <p className="mt-2">
          Add to your <b>Deluxe King Room - Smoking</b>
        </p>

        <div className="bed-options">
          <div className="checkbox-option">
            <input type="checkbox" id="isCribAvailable" defaultChecked name="isCribAvailable"  value={formData.isCribAvailable}
            onChange={handleChange}/>
            <label htmlFor="isCribAvailable" style={{marginRight:"50px"}}>Crib</label>
               Age :  <select className="form-control small-select" name="noOfCribs" value={formData.noOfCribs}
            onChange={handleChange}>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </select>
          </div>

          <div className="checkbox-option">
            <input type="checkbox" id="isExtraBedAvailable" defaultChecked name="isExtraBedAvailable"  value={formData.isExtraBedAvailable}
            onChange={handleChange}/>
            <label htmlFor="isExtraBedAvailable" style={{marginRight:"50px"}}>Extra bed</label>
           Age :  <select className="form-control small-select" name="noOfExtraBeds" value={formData.noOfExtraBeds}
            onChange={handleChange}>
              <option>17</option>
              <option>18</option>
              <option>19</option>
            </select>
          </div>
        </div>
      </div> */}

      {/* Bottom Action */}
      <div className="action-row">
        {/* <span className="price-match">🔖 We Price Match</span> */}
        <button className="next-btn" onClick={()=>handleSubmit()}>Next: Final details ➜</button>
      </div>
    </div>


<br />



{showPopup && (
  <BookingEmailVerificationPopup
    email={formData.email}
    // onVerify={handleVerifySuccess}
    onClose={() => setShowPopup(false)}
  />
)}



    </>
  );
};

export default FinalBookingForm;
